import React from 'react'
import { useViewport, viewportBreakpoint } from '../../../utils'

const CardFeatured = ({data, embed}) => {
  const {
    image,
    date,
    organization,
    title,
    excerpt,
    special
  } = data

  const { width } = useViewport()
  const breakpoint = viewportBreakpoint.tablet
  const isMobile = width < breakpoint
  const isTablet = width >= breakpoint && width < viewportBreakpoint.desktop
  const imageHeight = isMobile ? '150px' : '260px'
  const imageWidth = isMobile ? '150px' : '350px'
  const textColor = embed ? 'text-gray-444' : 'text-white'

  return (
    <div
      className={`rounded p-3 lg:p-5 flex flex-row`}
      style={{
        boxShadow: `0px 4px ${embed ? '10px' : '20px'} rgba(0, 0, 0, 0.05)`,
        background: embed ? '#fff' : '#255466'
      }}
    >
      <div
        className={`bg-no-repeat bg-cover mr-3 lg:mr-5 bg-center ${embed ? '' : isMobile || isTablet ? '' : 'mb-4'} lg:mb-0 rounded`}
        style={{height: imageHeight, minWidth: imageWidth, backgroundImage: "url('"+image+"')"}}
      />
      <div>
        <p className={`text-xs lg:text-sm font-bold ${textColor} ${!organization && 'mb-2'}`}>
          {date}
        </p>
        {
          organization &&
          <p className={`text-xs mb-2 ${embed ? 'text-gray-999' : 'text-white'}`}>
            {organization} /
          </p>
        }
        {
          special &&
          <div className="rounded px-1 text-white text-xs mb-2 inline-block" style={{background: '#FF5448'}}>Special Event</div>
        }
        <h3 className={`text-sm lg:text-base ${embed ? '' : 'text-white'} mb-2 font-bold font-primary ${embed ? 'text-sm' : ''} lg:text-2xl`}>
          {title}
        </h3>
        {
          excerpt &&
          <p className={`hidden lg:block text-sm ${textColor}`}>
            {excerpt}
          </p>
        }
      </div>
    </div>
  )
}

export { CardFeatured }
